

export function checkObjectValuesEqual (newValue: object, prevValue: object)
{
  const newKeys = Object.keys(newValue) as (keyof typeof newValue)[];
  const prevKeys = Object.keys(prevValue) as (keyof typeof prevValue)[];
  if (newKeys.length !== prevKeys.length) {
    return false;
  }
  newKeys.sort();
  prevKeys.sort();
  const allKeysEqual = newKeys.every((key, idx) => (key === prevKeys[ idx ]));
  if (allKeysEqual) {
    return newKeys.every(key => {
      const nVal = newValue[ key ];
      const pVal = prevValue[ key ];
      return nVal === pVal;
    });
  }
  return false;
}
